import script from "./ExchangeTicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExchangeTicker.vue?vue&type=script&setup=true&lang=ts"

import "./ExchangeTicker.vue?vue&type=style&index=0&id=0595b7cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0595b7cb"]])

export default __exports__